import * as React from "react";
import { cn } from "../lib";

const Card = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("rounded-2xl bg-white", className)} {...props} />
);

const CardHeader = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      "flex items-center justify-between rounded-t-2xl bg-[#F7F8FC] px-4 py-3",
      className,
    )}
    {...props}
  />
);

const CardTitle = ({
  className,
  children,
  ...props
}: React.ComponentProps<"h3">) => (
  <h3
    className={cn("text-lg font-semibold text-gray-30", className)}
    {...props}
  >
    {children}
  </h3>
);

const CardContent = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("p-4", className)} {...props} />
);

export { Card, CardHeader, CardTitle, CardContent };
